import { AppContent } from '../AppContent';

const mayfairAccountError: AppContent['mayfairAccountError'] = {
  mayfairAccountErrorContent: [
    {
      serviceName: 'Business Internet Banking',
      header: 'About the business',
      errorHeader: 'You’ll need to register a different way',
      errorSummary:
        'As a Mayfair account holder, you’ll need to register as a View Only User.',
      stepsHeader: 'Follow these steps to register:',
      stepOne: 'Fill out the registration form.',
      stepOneHref:
        'https://online-business.bankofscotland.co.uk/business/a/registration/selectRegistrationType.jsp',
      stepTwo: 'Print and sign the form.',
      stepThree: 'Post the form back to us.',
      backBtnLabel: 'Back to bankofscotland.com',
      backBtnHref: 'https://business.bankofscotland.co.uk/',
    },
  ],
};

export default mayfairAccountError;
